import React from 'react';
import { withNamespaces, Trans } from 'react-i18next';
import { staticURL } from 'core/url';

import Heading from 'components/Heading';
import Button from 'components/Button';
import { Spacer } from 'styles/utils';
import { Link } from 'core/routing';

import {
  JoinFullScreenSection,
  JoinTitleSectionStyled,
  JoinImageStyled,
  JoinContentStyled,
  MaxWidthWrapper,
} from '../styles';

const Join = withNamespaces()(() => {
  return (
    <JoinFullScreenSection color='wfWhite'>
      <MaxWidthWrapper>
        <JoinImageStyled>
          <img
            src={staticURL('assets/landing/complex.svg')}
            alt='background-image'
          />
        </JoinImageStyled>
        <JoinTitleSectionStyled>
          <JoinContentStyled>
            <Heading level='3' size='large'>
              <Trans>
                Join over 90.000 designers and engineers from all around the
                world.
              </Trans>
            </Heading>
            <Spacer size='large' />
            <Link name='home.signUp'>
              <Button
                text={<Trans>Sign up today</Trans>}
                icon='arrow_right'
                iconPosition='right'
                variant='primary'
              />
            </Link>
          </JoinContentStyled>
        </JoinTitleSectionStyled>
      </MaxWidthWrapper>
    </JoinFullScreenSection>
  );
});

export default Join;
